<template>
  <div class="moneyBox clear">
    <div class="moneyItem fl">
      <div>累计收益（元）</div>
      <div>{{moneyDetails.allEarningsAmount}}</div>
    </div>
    <div class="moneyItem fl">
      <div>待结算</div>
      <div>{{moneyDetails.waitSettlementAmount}}</div>
    </div>
    <div class="moneyItem fl">
      <div>可提现（元）</div>
      <div>
        <span>{{moneyDetails.allowWithdrawAmount}}</span>
        <el-button size="mini" class="txBtn" v-if="moneyDetails.allowWithdrawAmount >= 0" type="primary" @click="openWithdrawDialog">提现</el-button>
      </div>
    </div>
    <withdrawalDialog v-if="withdrawalDialogState" :moneyNum="moneyDetails.allowWithdrawAmount" @withdrawalDialogBtn="withdrawalDialogBtn" @closeDialog="withdrawalDialogState = false"></withdrawalDialog>
    <settlement v-if="settlementState" :moneyDetails="moneyDetails" :num="editNoticeData.amount" @settlementBtn="settlementBtn" @settlementClose="settlementClose"></settlement>
  </div>
</template>

<script>
import withdrawalDialog from './withdrawalDialog';
import settlement from './settlement'
import { mapState, mapActions } from 'vuex';
import property from '@/services/finance/property'
export default {
  data() {
    return {
      withdrawalDialogState: false,
      settlementState: false,
      editNoticeData: {},
    }
  },
  components: {
    withdrawalDialog, settlement
  },
  computed: {
    ...mapState({
      moneyDetails: state => state.finance.moneyDetails
    })
  },
  created () {
    this.getMoneyDetails()
  },
  methods: {
    ...mapActions(['getMoneyDetails', 'changWithdrawalState']),
    openWithdrawDialog () {
      this.withdrawalDialogState = true
    },
    withdrawalDialogBtn(data) {
      this.settlementState = true;
      this.editNoticeData = data
    },
    settlementBtn() {
      console.log(13123)
      this.withdrawHandle()
    },
    settlementClose() {
      this.settlementState = false;
      this.editNoticeData = {}
    },
    withdrawHandle() {
      property.withdrawHandle(this.editNoticeData).then(res => {
        if (res.code != 0) {
          this.$message.error(res.message)
        } else {
          this.$message.success(res.message);
          this.getMoneyDetails()
          this.changWithdrawalState(true)
          this.settlementState = false;
          this.withdrawalDialogState = false;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.moneyBox {
  text-align: center;
  line-height: 28px;
  .moneyItem {
    margin-right: 20px;
  }
  .txBtn {
    margin-left: 10px;
  }
}
</style>
